export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bot.snackbar.vue?vue&type=template&id=31f808ee&"


//////////////////
// WEBPACK FOOTER
// ./src/components/bot/snackbar/bot.snackbar.vue?vue&type=template&id=31f808ee&
// module id = 114
// module chunks = 16